(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gft-card-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
  if (event.key === ' ' && event.target.matches('[data-card-colour]')) {
    event.preventDefault();
    event.target.click();
  }
});
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-card-toggle]');
  if (toggle) {
    const active = toggle.closest('.gft-card-media').classList.toggle('is-alternate');
    toggle.setAttribute('aria-pressed', String(active));
    return;
  }
  const colour = event.target.closest('[data-card-colour]');
  if (!colour || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  const card = colour.closest('[data-card-preview]');
  if (!card) return;
  event.preventDefault();
  const primary = card.querySelector('.gft-card-media__primary');
  const secondary = card.querySelector('.gft-card-media__secondary');
  if (!primary || !secondary) return;
  for (const [image, source] of [[primary, colour.dataset.primary], [secondary, colour.dataset.secondary]]) {
    image.removeAttribute('srcset');
    image.src = source;
    image.alt = colour.dataset.imageAlt;
  }
  card.querySelectorAll('[data-card-link]').forEach(link => {
    link.href = colour.href;
    if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', colour.dataset.imageAlt);
  });
  card.querySelectorAll('[data-card-colour]').forEach(link => {
    link.setAttribute('aria-pressed', String(link === colour));
    link.removeAttribute('aria-current');
  });
  const price = card.querySelector('[data-card-price]');
  if (price) price.textContent = colour.dataset.price;
  card.querySelector('.gft-card-media').classList.remove('is-alternate');
  card.querySelector('[data-card-toggle]')?.setAttribute('aria-pressed', 'false');
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gft-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const button=event.target.closest('[data-size-open]');
  if(!button)return;
  const dialog=document.getElementById(button.dataset.sizeOpen);
  if(!dialog)return;
  const region=dialog.querySelector('.gft-size-scroll');
  const table=region.querySelector('table');
  if(!table.tHead){
    const row=table.rows[0];
    [...row.cells].forEach((cell,index)=>{const th=document.createElement('th');th.scope='col';th.textContent=index?cell.textContent:region.dataset.sizeLabel;cell.replaceWith(th)});
    table.createTHead().append(row);
    [...table.tBodies[0].rows].forEach(r=>{const cell=r.cells[0];const th=document.createElement('th');th.scope='row';th.textContent=cell.textContent;cell.replaceWith(th);if(th.textContent.trim()===region.dataset.selectedSize)r.dataset.current='true'});
  }
  dialog.showModal();
  dialog.addEventListener('close',()=>button.focus(),{once:true});
});
  } catch(e) { console.error(e); }
})();

})();
